module.exports = __webpack_public_path__ + "img/eb-l-nacs-logo.5031a593.png";